<template>
  <li>
    <em class="selectBoxEm">{{title}}</em>
    <span>
      <div v-if="disable" >
        <textarea v-if="multiline" class="selectBoxInputView" :value="getSelectTitle(selected)" v-show="false"></textarea>
        <input v-else type="text" class="selectBoxInputView" :value="getSelectTitle(items[selected])"  v-show="false">
        <div class="selectBoxInputView"><div style="width:500px">{{selectValue}}</div></div>
      </div>

      <div v-else-if="input_type==='date'">
        <div style="width: 0; height: 0; overflow: hidden">
          <datetime
              ref="calendar"
              style="background-color: white !important; border: 1px solid #ddd !important;"
              v-model="selectDate"
              :max-datetime="today"
              format="yyyy.MM.dd"
              :auto="true"
              @close="onCloseCalendar"
          ></datetime>
        </div>
        <div class="calendarWrap btnCalendar" @mousedown="onClickCalendar()">
          <div class="vdatetime-input">
            <span>{{selectDateValue}}</span>
          </div>
        </div>
      </div>

      <div v-else class="selectBox" >
        <div @click="activateSelect=true;">
          <div class="selectBoxInputView"><div style="width:500px">{{selectValue}}</div></div>
        </div>
        
        <popup v-if="activateSelect" @close="activateSelect=false"
          :isClosed="closed">
          <template #title>{{title}}</template>
          <template #content>
            <table class="tbl-form alignC pm-tbl-form" style="margin:0px;">
              <tbody class="pmTblFormTbody">
                <tr v-for="(item, key) in items" :key="key">
                  <th>
                    <input v-show="false"
                           type="radio"
                           :id="`${title}-${getSelectValue(item,key)}`"
                           :value="getSelectValue(item,key)"
                           v-model="select"
                           @change="$emit('update:val', select); activateSelect=false;"
                           readonly
                    />
                    <label style="padding-left: 10px;" :for="`${title}-${getSelectValue(item,key)}`"><span v-show="false"></span></label>
                  </th>
                  <td class="alignL" @click="$emit('update:val', getSelectValue(item,key)); activateSelect=false;">{{getSelectTitle(item)}}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </popup>
      </div>
    </span>

    <p v-if="input_type=='date'" class="fCol1 vMonth" >
      현재 {{regMonth}}개월
    </p>
  </li>
</template>

<script>
import Popup from '@/components/Popup/Popup.vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  name: "SelectBox",
  components: {
    Popup,
    Datetime,
  },
  props: {
    optionValId:{
      type:Boolean,
      default:false,
    },
    input_type: String,
    title: String,
    disable: Boolean,
    closed: {
      type: Boolean, 
      default: false
    },
    multiline: {
      type: Boolean, 
      default: false
    },
    selected: {
      type: [String, Number]
    },
    items: {
      type: [Array, Object]
    },
    val: null,
    date: null,
    setDate: null,
  },
  watch: {
    selected(val){
      this.select = val
      this.$emit('update:val', this.select);
    },
    date(val){
      this.selectDate = val;
    },
    selectDate(val) {
      if(this.input_type === 'date'){
        this.regMonth = this.getVehicleNumRegDiff(val);
        this.select = this.getVehicleNumRegMonthDiff(val);
        this.$emit('update:val', this.select);
        this.$emit('update:date', this.selectDate);
      }
    },
    activateSelect(val){
      if (val){
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
      } else {
        document.getElementsByTagName('body')[0].style.overflowY = 'auto';
      }
    },
  },
  computed: {
    selectValue() {
      let value = '선택';
      let item = '';
      
      if(this.items) {
        if(this.optionValId)
          item = this.items.find((i)=> i.id == this.select);
        else
          item = this.items[this.select];

        if(item !== undefined)
          value = this.getSelectTitle(item);
      }
      
      return value;
    },
    selectDateValue() {
      let value = '날짜를 선택해주세요.';
 
      if(this.selectDate) {
        value = this.selectDate.slice(0, 10);
      }

      return value;
    },
  },
  created() {
    this.select = this.selected;
    this.selectDate = this.date;
  },
  data() {
    return {
      today: this.$moment().toISOString(),
      selectDate: null,
      select: null,
      regMonth: 0,
      activateSelect: false,
    };
  },
  methods: {
    onClickCalendar(){
      this.$refs.calendar.isOpen = true;

      if(this.setDate != null) {
        this.selectDate = this.setDate;
        this.$emit('update:setDate', null);
      }

      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    },
    onCloseCalendar(){
      document.getElementsByTagName('body')[0].style.overflowY = 'auto';
    },
    getSelectValue(item, key) {
      return (this.optionValId) ? item.id: key
    },
    getSelectTitle(item) {
      if (item === undefined) return '';
      return item.title;
    }
  },
};
</script>

<style scoped>
p { text-align: center;}

textarea {
  resize: none;
  word-break:keep-all !important;
}
/* .calendarWrap{
  position:relative;
} */
.vMonth{
  display:table-cell;
  vertical-align: middle;
  text-align:center;
  font-size:13px;
  line-height: 140%;
}
</style>
